<template lang="pug">
  v-nav-tabs(
    :options="options"
    @tab-click="handleTabClick")
</template>

<script>
import navigationMixin from '@/mixins/navigation.mixin.js'

export default {
  name: 'StorageTabs',

  mixins: [navigationMixin],

  computed: {
    items () {
      const farmId = this.$route.params.farm_id
      const { stock } = this.$route.query
      const query = stock ? `?stock=${stock}` : ''

      return [
        {
          id: 0,
          title: 'base.ingredients',
          path: `stock/ingredients${query}${query ? '&' : '?'}farm=${farmId}&is_animalfeed=false`
        },
        {
          id: 1,
          title: 'base.fodder',
          path: `stock/fodder${query}${query ? '&' : '?'}farm=${farmId}&is_animalfeed=true`
        },
        {
          id: 2,
          title: 'base.deliveries',
          path: `stock/deliveries${query}${query ? '&' : '?'}farm=${farmId}`
        },
        {
          id: 3,
          title: 'base.delivery_company',
          path: 'stock/companies'
        },
      ]
    }
  },
  methods: {
    handleTabClick (tab) {
      if (tab.id === 0 || tab.id === 1) {
        this.$store.dispatch('ingredients/loadDailyFeedIntakesLoadData')
      }
    }
  }
}
</script>
